export const LATIN_COMPACT_WEEKDAY_LANGUAGES = new Set([
  "ca",
  "es",
  "fr",
  "gl",
  "it",
  "pt",
  "ro",
]);

export const getWeekdayText = (locale, date, weekday) => {
  try {
    return new Intl.DateTimeFormat(locale, { weekday })
      .format(date)
      .replace(/\.$/, "");
  } catch {
    return date.toLocaleDateString(locale, { weekday }).replace(/\.$/, "");
  }
};

const getWeekdayDates = () => {
  const monday = new Date(2024, 0, 1);
  return Array.from({ length: 7 }, (_, index) => {
    const date = new Date(monday);
    date.setDate(monday.getDate() + index);
    return date;
  });
};

export const shouldUseNarrowWeekdayLabels = ({
  isPhone,
  locale,
  i18nLanguage,
  calendarWidth,
  viewportWidth,
}) => {
  if (!isPhone) return false;

  const language = String(locale || i18nLanguage || "")
    .split("-")[0]
    .toLowerCase();

  if (!LATIN_COMPACT_WEEKDAY_LANGUAGES.has(language)) return false;

  const wrapperWidth = calendarWidth || viewportWidth || 0;
  if (!wrapperWidth) return true;

  const cellWidth = (wrapperWidth - 24) / 7;
  const labels = getWeekdayDates().map((date) =>
    getWeekdayText(locale, date, "short")
  );
  const longestLabelLength = labels.reduce(
    (max, label) => Math.max(max, label.length),
    0
  );
  const estimatedLabelWidth = longestLabelLength * 9;

  return estimatedLabelWidth > cellWidth - 4;
};
